<template>
  <div class="view">
    <!-- Use it like any other HTML element -->

    <!-- <div class="absolute left-0 top-0 text-red-600 z-50">
      View the sculpture in AR
    </div> -->
    <div class="text-3xl md:text-2xl border-2-border-red-600 uppercase px-4 py-2 mt-1 pointer-events-none absolute top-0 left-0 z-50 text-black">
      AR
    </div>

    <div class="close-view fixed right-4 top-4 z-50">
      <router-link :to="{ name: 'Home', params: {} }" class="w-8 h-8 block group block lg:hidden">
        <div class="absolute top-1/2 right-0 transform rotate-45 h-0.5 w-8 bg-black group-hover:bg-red-600"></div>
        <div class="absolute top-1/2 right-0 transform -rotate-45 h-0.5 w-8 bg-black group-hover:bg-red-600"></div>
      </router-link>

      <router-link :to="{ name: 'Home', params: {} }" class="w-8 h-8 block group hidden lg:block">
        <div class="absolute top-1/2 right-0 transform rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
        <div class="absolute top-1/2 right-0 transform -rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
      </router-link>
    </div>

    <router-link class="hidden lg:block absolute z-0 inset-0 bg-black bg-opacity-50" :to="{ name: 'Home', params: {} }">
    </router-link>

    <model-viewer
    ref="mv"
    class="absolute inset-0 w-full h-full block lg:hidden"
    src="https://hato-public.s3.amazonaws.com/assets/gonogo/modelDraco3.gltf"
    ios-src="https://hato-public.s3.amazonaws.com/assets/gonogo/goshka-macuga-gonogo-4.usdz"
    camera-orbit="20deg 105deg 130%"
    camera-target="0 0 0"
    field-of-view="90"
    alt="GOSHKA MACUGA GO NO GO"
    ar ar-modes="quick-look"
    ar-scale="auto"
    auto-rotate
    >
      <a
      slot="ar-button"
      :class="{
        'opacity-25': !isTouch || isInAppBrowser,
        'pointer-events-none': !isTouch || isInAppBrowser
        }"
      class="text-xl md:text-2xl text-red-600 border-2 border-red-600 uppercase px-2 py-1 mt-1 cursor-pointer pointer-events-auto hover:border-red-600 hover:text-red-600 absolute bottom-4 left-4 right-4 text-center">
        Start
      </a>
    </model-viewer>

    <div class="fixed inset-0 pointer-events-none z-50 text-black flex items-end justify-center lg:justify-start p-4 text-red-600 pointer-events-none text-lg lg:text-xl text-center lg:text-left">

      <div class="p-8 shadow-lg rounded-sm max-w-screen-sm hidden lg:block fixed bg-red-600 text-white w-96 top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 pointer-events-auto" v-if="!isTouch">
        <img src="/images/qr.png" alt="" class="max-w-full w-full">
        <div class="pointer-events-auto px-5-pb-5 mt-4">
          Visit <a href="https://gonogo.space/utm_source=webar" target="_blank">gonogo.space</a> on your mobile to launch AR.<br><br>Record and submit your AR rocket experience by tagging <a href="https://instagram.com/gonogo.space" rel="nofollow noopener" target="_blank">@gonogo.space</a> on Instagram for a chance to be featured.
        </div>
      </div>

      <div class="pb-0 mb-2 max-w-screen-sm block lg:hidden" v-if="!isTouch">
        <div class="pointer-events-auto">
          Visit <a href="https://gonogo.space/utm_source=webar" target="_blank">gonogo.space</a> on your mobile to launch AR.<br><br>Record and submit your AR rocket experience by tagging <a href="https://instagram.com/gonogo.space" rel="nofollow noopener" target="_blank">@gonogo.space</a> on Instagram for a chance to be featured.
        </div>
      </div>

      <div class="pb-12 mb-2" v-if="isTouch&&!isInAppBrowser">
        <span class="pointer-events-auto inline-block mb-2">Record and submit your AR rocket experience by tagging <a href="https://instagram.com/gonogo.space" rel="nofollow noopener" target="_blank">@gonogo.space</a> on Instagram for a chance to be featured.</span>
          <div class="mt-2 text-xs">GO NO GO launches to scale. You may need to scale it down for indoor viewing or load in an open space.</div>
      </div>

      <div class="pb-12 mb-2" v-if="isTouch&&isInAppBrowser">
        Please open this page on <span v-if="OperatingSystem=='iOS'">Safari</span><span v-else>Chrome</span> for AR experience
      </div>

    </div>

  </div>
</template>

<script>
// import mdFile from '@/markdown/about.md'
// @ is an alias to /src
import '@google/model-viewer';

export default {
  name: 'AR',
  data () {
    return {
      text: ''
    }
  },

  mounted () {
    const ModelViewerElement = this.$refs.mv
    ModelViewerElement.dracoDecoderLocation = '/draco/';
  },

  computed: {
    stage () {
      return this.$store.state.stage
    },
    isTouch () {
		  return (('ontouchstart' in window) ||
		     (navigator.maxTouchPoints > 0) ||
		     (navigator.msMaxTouchPoints > 0));
    },
    isInAppBrowser () {
      // return true
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      let isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
      let isFacebook = (ua.indexOf('Facebook') > -1) ? true : false;
      let isMessenger = (ua.indexOf('Messenger') > -1) ? true : false;
      // if (document.documentElement.classList){
      // 	if (isInstagram||isFacebook||isMessenger) {
      // 		// window.document.body.classList.add('instagram-browser');
      //     return true
      // 	} else {
      //     return false
      //   }
      // }
      // return true
      return (isInstagram||isFacebook||isMessenger) ? true : false
    },
    OperatingSystem () {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "iOS";
      }

      return "unknown";
    },
    ios () {
      return this.OperatingSystem() == 'iOS'
    },
    android () {
      return this.OperatingSystem() == 'Android'
    }
    // md () {
    //   return mdFile
    // }
  }
}
</script>

<style lang="scss" scoped>
.view {
  pointer-events: auto;
  @apply fixed inset-0 z-10;
  @apply bg-white;
  @screen lg {
    @apply bg-transparent;
  }
  z-index:99999;
}
</style>
